import { IStore } from 'Store/.';

const getIsFetching = (state: IStore) => state.ticket.isFetching;
const getIsFetchFailed = (state: IStore) => state.ticket.isFetchFailed;
const getIsTicketNotFound = (state: IStore) => state.ticket.isTicketNotFound;
const getTicketSummary = (state: IStore) => state.ticket.ticketSummary;

export {
  getIsFetching,
  getIsFetchFailed,
  getIsTicketNotFound,
  getTicketSummary,
};


// WEBPACK FOOTER //
// ./src/pages/TicketPage/Redux/selectors.tsx